var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$slots.default
    ? _c(
        "div",
        { staticClass: "container-with-icon", class: _vm.additionalClass },
        [
          _vm.icon
            ? _c("div", { staticClass: "icon" }, [
                _c("img", { attrs: { src: _vm.icon, alt: "" } })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content", class: _vm.contentClass },
            [
              _vm.titleType == "h4"
                ? _c("h4", [_vm._v(_vm._s(_vm.title))])
                : _vm.titleType == "h3"
                ? _c("h3", [_vm._v(_vm._s(_vm.title))])
                : _c("h1", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }